import config from '@/config'

export default {
  combine: {
    confirm_password: "Подтвердите @:ui.password",
    change_password: "Изменить @:ui.password",
    old_password: "Старый @:ui.password",
    new_password: "@:ui.new @:ui.password",
    confirm_security_code: "Подтвердите @:ui.security_code",
    first_time_login: "Первый вход в систему",
    security_authentication: "Проверка безопасности",
    update_security: "Обновить безопасность ",
    disable_security: "Отключить безопасность",
    add_account: "Добавить аккаунт",
    add_sub_account: "Добавить суб-аккаунт ",
    edit_operator: "Редактировать Оператор",
    edit_account: "Редактировать учетную запись",
    edit_member: "Редактировать Участник",
    approve_ticket: "Одобрить Тикет ",
    reject_ticket: "Отклонить Тикет ",
    add_bank_account: "Добавить банковский счет ",
    edit_bank_account: "Редактировать банковский счет",
    reset_threshold: "Сбросить порог",
    adjust_balance: "Корректировать баланс",
    adjust_member: "корректировать участника",
    configure_bank_setting: "Настроить параметры банка",
    account_setup: "Настройки аккаунта",
    bank_transfer: "Банковский перевод",
    edit_bank_member: "Редактировать банк участника",
    edit_ticket: "Редактировать Тикет ",
    edit_vip: "Редактировать VIP ",
    knock_off_promo: "Выключить промоакцию",
    edit_authority: "Редактировать полномочия",
    reset_password: "Сбросить пароль",
    update_password: "Обновить пароль",
    member_summary: "Краткий отчет участника",
    reply_review: "Ответить на отзыв",
    edit_affiliate : "Редактировать Агент ",
    edit_bank_affiliate : "Редактировать Банк Агента",
    approve_affiliate_ticket: "Подтвердить Тикет агента ",
    check_free_spin: "Проверить Фри Спин",
    reject_affiliate_ticket: "Отклонить Тикет агента",
    wallet_adjust: "Корректировать кошелек",
    update_comm_package: "Обновить пакет связи",
    approve_affiliate : "Одобрить агента",
    sub_acc_detail_affiliate : "Подробная информация по суб-аккаунту агента",
    get_tac: "Запросить одноразовый пароль",
    add_coupon: "Добавить Купон",
    update_coupon: "Обновить Купон",
    issue_free_spin: "Выдать фри спин",
    get_bank_tac: "Запросить одноразовый пароль банка",
    update_global_setting: "Обновить глобальные настройки",
    add_platform: "Добавить Платформу",
    edit_platform: "Редактировать Платформу",
    add_bank_group: "Добавить Группу Банков",
    edit_bank_group: "Редактировать Группу Банков",
    update_maintenance_schedule: "Обновить расписание технических работ",
    add_withdrawal_limit: "Добавить лимит вывода",
    edit_withdrawal_limit: "Редактировать лимит вывода",
    add_campaign: "Добавить Кампанию",
    edit_campaign: "Редактировать Кампанию ",
    add_promo_group: "Добавить Группу Промоакций",
    edit_promo_group: "Редактировать Группу Промоакций",
    update_team: "обновить Команду",
    update_result: "Обновить Результат",
    insert_result: "Вставить Результат",
    bet_list: "Список Ставок",
    result_list: "Список Результатов",
    add_promo: "Добавить Промоакцию",
    raise_deposit_ticket: "Поднять Тикет Депозита",
    bank_adjust: "Корректировать Банк",
    promo_member_assign: "Назначить участника промоакции",
    bonus_issue: "Выпуск бонуса",
    update_vip: "Обновить VIP",
    update_member_profile: "Обновить профиль участника",
    change_withdrawal_limit: "Изменить лимит вывода",
    change_bank_group: "Изменить группу банков",
    change_promotion_group: "Изменить группу промоакций",
    edit_promo_signup: "Редактировать промоакцию за регистрацию",
    update_provider_bet_limit: "Обновить лимит ставки провайдера",
    update_bet_limit: "Обновить лимит ставки",
    update_member_bet_limit: "Обновить лимит ставки участника",
    edit_bank_account_group: "Редактировать группу банковских счетов",
    redeposit_ticket: "Повторный депозит тикета",
    edit_promotion_group: "Редактировать группу промоакций",
    edit_promotion_group_norm: "Управлять промоакциями в группе",
    get_inbox_list: "Получить список входящих",
    view_result_changes_detail: "Посмотреть подробную информацию по изменениям результатов",
    edit_promotion_signup: "Редактировать регистрацию промоакций",
    edit_bet_limit: "Редактировать лимит ставок",
    edit_provider_game_off: "Редактировать выключение игр провайдера",
    edit_provider_rtp: "Редактировать RTP провайдера",
    get_rebate: "Получить скидку",
    get_recent_deposit: "Получить последний депозит ",
    add_survey: "Добавить опрос",
    add_announcement_banner: "Добавить  баннер с объявлением",
    edit_announcement_banner: "Редактировать баннер с объявлением",
    move_announcement_banner: "Переместить баннер с объявлением",
    add_promotion_banner: "добавить баннер промоакции",
    edit_promotion_banner: "Редактировать баннер промоакции",
    unlink_banner: "Отвязать",
    move_promotion_banner: "Переместить баннер промоакции",
    add_slide_banner: "Добавить слайд баннер",
    edit_slide_banner: "Редактировать слайд баннер",
    move_slide_banner: "Переместить слайд баннер",
    add_seo_page: "Добавить SEO страницу",
    edit_seo_page: "Редактировать SEO страницу",
    clear_outstanding: "Очистить непогашенные",
    add_ip_whitelist: "Добавить белый список IP-адресов",
    bonus_issue_bulk: "Массовый выпуск бонусов",
    edit_bank_member_ewallet: "Редактировать банк участника (Электронный кошелек)",
    redeposit: "Повторный депозит",
    reject_approved_ticket: "Отклонить одобренный тикет",
    audit_ticket: "Аудит тикета",
    review_ticket: "Проверить тикет ",
    edit_promotion_group_norm_seq: "Управлять последовательностью промоакций в группе",
    edit_promo_provider_list: "Редактировать список промоакций провайдеров",
    edit_promo_payment_option: "Редактировать ",
    edit_campaign_provider_list: "Редактировать список кампаний провайдера",
    update_comm: "Обновить комиссию ",
    update_carry_over: "Обновить перенос",
    review_affiliate_ticket: "Проверить тикет агента",
    audit_affiliate_ticket: "Провести аудит тикета агента",
    get_tac_affiliate : "Получить одноразовый пароль (агент) ",
    raise_deposit_ticket_gateway: "Поднять Тикет Депозита (платежный сервис)",
    direct_audit_ticket: "Провести аудит тикета (прямой)",
    get_rollback_detail: "Получить подробную инфорацию отката",
    get_reject_detail: "Получить подробную информацию отказа",
    manual_approve_ticket: "Одобрить тикет (ручной)",
    add_label: "Добавить ярлык ",
    edit_label: "Редактировать ярлык",
    rollback_processing_ticket: "Откат обработки тикета",
    update_iframe_url: "Обновить iframe URL ",
    edit_exchange_rate: "Редактировать курс обмена",
    add_vip: "Добавить VIP",
    add_turnover_tier: "Добавить уровень отыгрыша",
    edit_turnover_tier: "Редактировать уровень отыгрыша",
    edit_mission_reward: "Редактировать награду за миссию",
    enable_mission_reward: "Включить награду за миссию",
    get_member_label_list: "Список ярлыков участников",
    add_rescue_fund: "Добавить фонд спасения",
    get_custom_member_list: "Пользовательский список участников ",
    get_rescue_fund_provider: "Получить фонд спасения провайдера",
    add_game_exclude: "Добавить исключить игру",
    delete_game_exclude: "Удалить исключить игру",
    domain_custom_add_assign: "Добавить домен",
    add_domain_batch: "Добавить домен (Batch) ",
    update_payment_provider_vip: "Обновить VIP платежного провайдера",
    update_campaign: "обновить кампанию",
    purchase_domain: "Купить домен",
    apply_domain: "Применить домен",
    edit_access_control: "Редактировать контроль доступа",
    add_domain: "добавить домен",
    operator_wallet_adjust: "Корректировать кошелек оператора",
    update_payment_provider_desc: "Обновить описание платежного провайдера",
    add_package: "@:ui.add @:ui.package",
    edit_package: "@:ui.edit @:ui.package",
    add_theme_content: "@:ui.add @:ui.theme_content",
    edit_theme_content: "@:ui.edit @:ui.theme_content",
    add_theme: "@:ui.add @:ui.theme",
    edit_theme: "@:ui.edit @:ui.theme",
    add_color: "@:ui.add @:ui.color",
    edit_color: "@:ui.edit @:ui.color",
    add_content: "@:ui.add @:ui.content",
    edit_content: "@:ui.edit @:ui.content",
    delete_content: "@:ui.delete @:ui.content",
    update_setting: "@:ui.update @:ui.setting",
    add_theme_content_group: "@:ui.add @:ui.theme_content_group",
    edit_theme_content_group: "@:ui.edit @:ui.theme_content_group",
    add_bo_default_domain: "@:ui.add @:ui.bo_default_domain",
    edit_bo_default_domain: "@:ui.edit @:ui.bo_default_domain",
    update_theme: "@:ui.update @:ui.theme",
    update_menu: "@:ui.update @:ui.menu",
    update_game_menu: "@:ui.update @:ui.game_menu",
    update_special_menu: "@:ui.update @:ui.special_menu",
    update_setting_menu: "@:ui.update @:ui.setting_menu",
    update_profile_setting: "@:ui.update @:ui.profile_setting",
    update_operator_setting: "@:ui.update @:ui.operator_setting",
    add_social_account: "@:ui.add @:ui.social_account",
    edit_social_account: "@:ui.edit @:ui.social_account",
    add_site_info: "@:ui.add @:ui.site_info",
    edit_site_info: "@:ui.edit @:ui.site_info",
    add_ads: "@:ui.add @:ui.advertisement",
    edit_ads: "@:ui.edit @:ui.advertisement",
    edit_provider_hot_game: "@:ui.edit @:ui.provider @:ui.hot_game",
    edit_provider_new_game: "@:ui.edit @:ui.provider @:ui.new_game",
    edit_provider_popular_game: "@:ui.edit @:ui.provider @:ui.popular_game",
    edit_provider_featured_game: "@:ui.edit @:ui.provider @:ui.featured_game",
    setup_logo: "Настройки логотипа",
    add_livechat: "@:ui.add @:ui.livechat",
    update_livechat: "@:ui.update @:ui.livechat",
    provider_pt_operator_update: "Обновление Provider PT Operator ",
    provider_pt_global_update: "Обновление Provider PT Global ",
    payment_option_callback_update: "Обновление callback URL",
    change_payment_option_seq: "Последовательность платежных опций",
    change_payment_mode_status: "Обновить статус платежной опции",
    change_payment_option_recommend: "Рекомендовать платежную опцию ",
    change_payment_option_credential: "Учетные данные платежного метода",
    change_payment_option_limit: "Лимит платежной опции",
    change_payment_option_vip: "VIP платежная опция ",
    add_mini_game: "@:ui.add @:ui.mini_game",
    edit_mini_game: "@:ui.edit @:ui.mini_game",
    add_mini_game_template: "@:ui.add @:ui.mini_game_template",
    edit_mini_game_template: "@:ui.edit @:ui.mini_game_template",
    edit_reward: "@:ui.edit @:ui.reward",
    gamify_update: "@:ui.update @:ui.reward",
    add_free_game_token: "@:ui.add @:ui.free_game_token",
    add_partners: "@:ui.add @:ui.partners",
    edit_partners: "@:ui.edit @:ui.partners",
    add_leaderboard: "@:ui.add @:ui.leaderboard",
    edit_leaderboard: "@:ui.edit @:ui.leaderboard",
    add_phone: "@:ui.add @:ui.phone",
    adjust_free_balance: "Корректировка свободного баланса",
    edit_ai_assistant: "@:ui.edit @:ui.ai_assistant",
    change_payment_option_desc: "Описание варианта оплаты",
    fund_transfer_provider: "Провайдер перевода средств",
    manual_deposit: "Ручной депозит",
    change_linkage_desc: "Описание связи",
    change_linkage_risk_weight: "Вес риска связи",
    add_promo_voucher: "@:ui.add @:ui.promotion_voucher",
    edit_promotion_voucher_end_date: "@:ui.edit @:ui.promotion_voucher @:ui.end_date",
    get_voucher_custom_member_list: "Получить пользовательский список участников для ваучера",
    redeposit_ticket_voucher: "Повторное внесение ваучера тикета",
    approve_ticket_voucher: "Одобрить ваучер тикета",
    reject_ticket_voucher: "Отклонить ваучер тикета",
    raise_deposit_ticket_voucher: "Создать ваучер тикета на депозит",
    raise_deposit_ticket_voucher_gateway: "Создать ваучер тикета на депозит (шлюз)",
    get_voucher_list: "Получить список ваучеров",
    get_message_list: "Получить список сообщений",
    edit_free_credit: "@:ui.edit @:ui.free_credit",
    knock_off_free_credit_member: "Отменить участника бесплатного кредита",
    free_credit_manual_assign: "Ручное назначение бесплатного кредита",
    review_fcp_ticket: "Проверить тикет провайдера бесплатного кредита",
    audit_fcp_ticket: "Аудит тикета провайдера бесплатного кредита",
    reject_fcp_ticket: "Отклонить тикет провайдера бесплатного кредита",
    approve_fcp_ticket: "Одобрить тикет провайдера бесплатного кредита",
    edit_trigger: "Редактировать триггер",
    edit_trigger_status: "Редактировать статус триггера",
    adjust_voucher_balance: "Изменить баланс ваучера",
    clear_free_credit: "Очистить бесплатный кредит",
    add_deposit_tier: "Добавить уровень депозита",
    edit_deposit_tier: "Изменить уровень депозита",
    add_leaderboard_banner: "Добавить баннер таблицы лидеров",
    edit_leaderboard_banner: "Редактировать баннер таблицы лидеров",
    add_referral_banner: "Добавить реферальный баннер",
    edit_referral_banner: "Редактировать реферальный баннер",
    edit_vip_icon: "Редактировать VIP-значок",
    add_reward_rain: "Добавить Reward Rain",
    edit_reward_rain: "Редактировать Reward Rain",
    add_reward_rain_session: "Добавить сессию Reward Rain",
    edit_reward_rain_session: "Редактировать сессию Reward Rain",
    edit_reward_rain_session_end_date: "Изменить дату окончания сессии Reward Rain",
    add_news: "Добавить новость",
    edit_news: "Редактировать новость",
  },
  short: {
    deposit_amount: "Сумма де",
    base_amount: "Базовая сумма",
    bonus_amount: "Сумма бонуса",
    target_amount: "Целевая сумма",
    knockoff_by: "Завершено ",
    knockoff_date: "дата завершения",
    incoming_threshold: "Вход порог",
    incoming_frequency: "Вхо частота",
    outgoing_threshold: "Исход порог",
    outgoing_frequency: "Исход частота",
    account_balance: "Баланс акк",
    claim_type: "Тип претензии",
    bonus_rate: "Процент бонуса",
    max_bonus: "Макс бонус",
    rollover: "Ролловер",
    criteria: "Критерии",
    start_time: "Время начала",
    end_time: "Время окончания",
    monday: "Пн ",
    tuesday: "Вт",
    wednesday: "Ср",
    thursday: "Чет",
    friday: "Пт",
    saturday: "Сб",
    sunday: "Вс",
    status: "Статус",
    bonus_rate_percent: "Процент бонуса (%)",
    valid_turnover: "Действительный отыгрыш",
    deposit_count: "Кол-во деп",
    withdrawal_amount: "Сумма вывода",
    withdrawal_count: "Кол-во выводов",
    adjustment_amount: "Корректировка суммы",
    referee_count: "Количество судей",
    signup_count: "Количество регистраций",
    verified_count: "Количество верифицированных",
    active_member: "Активный участник ",
    ftd_count: "Кол-во ПД ",
    ftd_amount: "сумма ПД ",
    working_date: "Дата работы",
    recipient_bank_id: "ID банка получателя",
    recipient_bank_acc_no: "Номер банковского счета получателя",
    recipient_bank_acc_holder: "Владелец банковского счета получателя ",
    sender_bank: "Банк отпраителя",
    sender_bank_acc_no: "Номер банковского счета отправителя",
    sender_bank_acc_holder: "Владелец банковского счета отправителя",
    unique_login_count: "Количество уникальных входов в систему",
    unique_deposit_count: "Количество уникальных депозитов",
    unique_withdrawal_count: "Количество уникальных выводов",
    second_deposit_count: "Количество вторых депозитов",
    reject_date: "Дата отказа",
    processing_date: "Дата обработки ",
    deposit_withdrawal_different: "Разница деп/вывод",
    external_id: "Внешний ID",
    draft_version: "Черновая версия",
    prod_version: "Рабочая версия",
    purchased_date: "Дата покупки",
    completed_amount: "Завершенная сумма",
    min_amount: "Мин. сумма",
    max_amount: "Макс. сумма",
    total_claimed_amount: "Общая полученная сумма",
  },
  date_ranges: {
    0: "сегодня",
    1: "вчера",
    2: "Текущий месяц",
    4: "Прошлый месяц",
  },
  langList: {
    EN: "английский",
    CN: "китайский",
    PHP: "филиппинский",
    esp: "испанский",
    RUS: "русский",
    VI: "Вьетнамский",
    MS: "Малайский",
    NE: "Непальский",
    CT: "Китайский (Тайвань)",
    BN: "Бенгальский"
  },
  menulist: {
    home: "Главная",
    hot: "Горячий",
    slot_game: "Слот",
    casino: "Казино",
    sportsbook: "Спорт",
    fishing: "Рыбалка",
    lottery: "Лотерея",
    poker: "Покер",
    hash_game: "Хеш игра",
    sabong: "Сабонг",
    promotion: "Промоакция ",
    review: "Обзор",
    news: "Новости",
    live_stream: "Прямой эфир ",
    vip: "VIP",
    referral: "Реферральный ",
    favourite: "Избранный",
    mission: "Миссия (мини игра) ",
    spin: "Вращение",
    leaderboard: "Таблица лидеров",
    account: "Аккаунт",
    deposit: "Депозит",
    withdrawal: "Вывод ",
    bet_history: "История ставок",
    pending_status: "Статус на рассмотрении",
    change_password: "Изменить @:ui.password",
    profile: "Профиль",
    banking_details: "Банковские реквизиты",
    inbox: "Входящие",
    voucher: "Ваучер",
    wallet: "Кошелек",
    statement: "Выписка",
    download: "Загрузить",
    game: "Игра",
    special: "Специальный",
    misc: "Разное",
    contact_us: "контакты ",
    e_sportsbook: "E-Sportsbook",
    lotto: "Лотто",
    p2p: "P2P",
    other: "Другое",
    vip2: "VIP2",
    referral2: "Реферрал2",
    event: "Событие",
    daily_reward: "Ежедневная награда",
    play2earn: "play2earn (играй, чтобы заработать)",
    redemption: "Выкуп",
    card_board: "Настольные игры",
    lobby: "Холл",
    in_house: "В доме",
    transfer: "Перевод",
    horse_racing: "Конные скачки",
    register: "Зарегестрироваться",
    login: "Логин",
    transaction_history: "История платежей",
    bingo: "Бинго",
    member: "Участник",
    arcade: "Аркада",
    crash: "Креш",
    freeplay: "Бесплатная игра",
    others: "другое",
  },

  ok: "Ок",
  cancel: "Отменить",
  login: "Логин",
  logout: "Выйти",
  add: "Добавить",
  edit: "Редактировать",
  delete: "Удалить",
  refresh: "Обновить",
  action: "Действие",
  id: "ID",
  name: "имя",
  all: "все",
  search: "поиск",
  remove: "Удалить",
  save: "Сохранить",
  account: "Аккаунт",
  settings: "Настройки",
  on: "ВКЛ",
  off: "ВЫКЛ",
  new: "Новый",
  clear: "Очистить",
  users: "Пользователь / пользователи",
  username: "Имя пользователя",
  password: "Пароль",
  created_on: "Создать на",
  active: "Активный",
  page_size: "Размер страницы",
  status: "Статус",
  result: "Результат",
  close: "Закрыть",
  back: "Назад",
  show: "Показать",
  login_id: "Логин ID",
  date_time: "Дата время",
  ip_address: "Ip адрес",
  domain_name: "Имя домена",
  browser_agent: "Агент браузера",
  action_by: "Действием",
  details: "Детали",
  key: "Ключ / ключи",
  value: "Ценность / ценности",
  from: "От",
  to: "До",
  type: "Тип",
  criteria: "Критерии",
  log: "Журнал",
  report: "Отчет",
  security_tag: "Тег безопасности",
  security_code: "Код безопасности",
  submit: "Подать",
  disable: "Отключить",
  operators: "Оператор / операторы",
  members: "Участники",
  account_id: "ID аккаунта",
  confirm_password: "Подтвердите @:ui.password",
  full_name: "Полное имя",
  contact_phone: "Контактный номер телефона",
  contact_email: "Контактный адрес e-mail",
  dashboard: "Панель инструментов",
  sub_account: "Суб-аккаунт",
  authority_option: "Опция Полномочия",
  banks: "Банк/ банки",
  login_ip : "Ip входа в систему",
  block: "Блок",
  profile_id: "ID профиля",
  suspend: "Приостанавливать",
  mail_address: "Почтовый адрес",
  deposit: "Депозит",
  withdrawal: "Вывод ",
  bulk_withdrawal: "Массовый вывод",
  rejected: "Отклонено",
  processed: "Оброботано",
  pending: "в обработке ",
  member: "Участник",
  amount: "Сумма",
  bank_acc_no: "Номер банковского счета ",
  deposit_date: "Дата депозита",
  deposit_method: "Способ депозита",
  approve: "Одобрить",
  reject: "Отклонить",
  remark: "Пометить",
  ticket_detail: "подробная информация тикета",
  promo: "Промо",
  package: "Пакет",
  created_date: "Дата создания",
  currency: "Валюта",
  bank_acc_holder: "Владелец банковского счета",
  ref_no: "Реф номер",
  vip: "VIP",
  modified_date: "Дата изменения",
  modified_by: "Изменено",
  bank_member: "Банк участника",
  bank_operator: "Банк оператора",
  bank_name: "Название банка",
  bank_acc_type: "Тип банковского счета",
  account_balance: "Баланс акк",
  threshold: "Порог",
  incoming: "Входящие ",
  outgoing: "Исходящие",
  frequency: "Частота",
  reset_threshold: "Сбросить порог",
  adjust_balance: "Корректировать баланс",
  bank_from: "Банк от",
  bank_to: "Банк до",
  attachment: "Вложение",
  sender_bank: "Банк отпраителя",
  sender_bank_acc_no: "Номер банковского счета отправителя",
  sender_bank_acc_holder: "Владелец банковского счета отправителя",
  audit: "Проводить аудит",
  action_status: "Статус действия",
  action_date: "Дата действия",
  promotion: "Промоакция ",
  promo_id: "ID промо",
  promo_name: "Название промо",
  package_id: "ID пакета ",
  claim_type: "Тип претензии",
  bonus_rate: "Процент бонуса",
  max_bonus: "Макс бонус",
  rollover: "Ролловер",
  start_date: "Дата начала",
  end_date: "Дата окончания",
  adj_amount: "Корректировать сумму",
  promotion_member: "Участник промоакции",
  on_going: "В процессе",
  knock_off: "Выключить",
  all_ongoing: "Все в процессе",
  deposit_amount: "Сумма де",
  base_amount: "Базовая сумма",
  bonus_amount: "Сумма бонуса",
  target_amount: "Целевая сумма",
  claim_date: "Дата заявки",
  accumulate_win: "Накопить выигрыш",
  accumulate_turnover: "Накопить отыгрыш",
  bonus: "Бонус",
  bonus_log: "Журнал бонусов",
  member_id: "ID участника",
  before_balance: "Баланс до",
  transfer_amount: "Сумма перевода",
  after_balance: "Баланс после",
  created_by: "Создано",
  bonus_name: "Название бонуса",
  bonus_desc: "Описание бонуса",
  bonus_type: "Тип бонуса",
  add_promo: "Добавить Промоакцию",
  bonus_value: "Величина бонуса",
  attach_promo: "Прикрепить промоакцию",
  daily_statement: "Ежедневный отчет",
  working_date: "Дата работы",
  opening_balance: "Открывающий баланс",
  turnover: "Отыгрыш",
  valid_turnover: "Действительный отыгрыш",
  winlose: "Выиграть проиграть",
  withdrawal_amount: "Сумма вывода",
  closing_balance: "Закрывающий баланс",
  sub_total: "Промежуточный итог",
  grand_total: "Итоговая сумма",
  daily_winlose: "Ежедневный выигрыш/проигрыш",
  game_result_slots: "Результаты  игры (Слоты)",
  game_result_livecasino: "Результаты  игры (LIVE-казино)",
  game_result_rebate: "Результаты  игры (Скидка)",
  game_result_sportsbook: "Результаты  игры (Спорт)",
  game_result_cockfight: "Результаты  игры (Петушиные бои)",
  game_result_rescue: "Результаты  игры (Спасение)",
  game_result_others: "Результаты  игры (Другие)",
  bet_count: "Количество ставок",
  result_id: "ID результата",
  bet_time: "Время ставки ",
  result_time: "Время результата",
  payout: "Выплата",
  game_type: "Тип игры",
  game_name: "Название игры",
  game_provider: "Провайдер игры",
  reset: "Сбросить",
  mode: "Режим",
  balance: "Баланс",
  min_bal_knock_off_promo: "Минимальный баланс (для автоматического выключения промоакции)",
  social_account: "Социальный аккаунт",
  wechat: "WeChat",
  telegram: "Telegram",
  whatsapp: "Whatsapp",
  facebook: "Facebbok",
  instagram: "Instagram",
  login_log: "Журнал входа",
  platform: "Платформа",
  bank_statement: "Выписка из банка",
  transfer_date: "Дата перевода",
  detail: "Подробная информация ",
  date: "Дата",
  transfer_list: "список переводов ",
  credit: "Кредит ",
  badge: "Значок",
  debit: "Дебит",
  month: "Месяц",
  unblock: "Разблокировать",
  unblock_member: "Разблокировать участника",
  unblock_operator: "Разблокировать оператора",
  referrer_id: "ID реферала",
  referrer_code: "Код рефера ",
  referral_code: "Реферальный код ",
  bonus_and_adjustment: "Бонус и корректировка",
  adjustment: "Корректировка",
  incoming_amount_threshold: "Порог входящей суммы",
  outgoing_amount_threshold: "Порог исходящей суммы",
  knock_off_by: "Выключено",
  knock_off_date: "Дата выключения",
  total_turnover: "Всего отыгрыш",
  total_winlose: "Всего выигрыш/проигрыш",
  total_deposit: "Всего депозитов",
  total_member: "Всего участников",
  active_player: "Активный игрок",
  top_winner: "Топ победитель",
  top_loser: "Топ проигравший",
  winner: "Победитель",
  loser: "Проигравший",
  deposit_count: "Количество депозитов",
  withdrawal_count: "Количество выводов",
  alert: "Тревога",
  incoming_threshold: "Вход порог",
  incoming_frequency: "Вхо частота",
  outgoing_threshold: "Исход порог",
  outgoing_frequency: "Исход частота",
  reset_password: "Сбросить пароль",
  transfer: "Перевод",
  company_bank: "Банк компании",
  company_bank_acc_no: "Номер банковского счета компании",
  company_bank_acc_holder: "Владелец банковского счета компании",
  registered_member: "Зарегистрированный участник",
  promotion_report: "Отчет промоакций",
  deposited_member: "Участник с депозитом",
  referred_member: "реферальный участник",
  validated_on: "Проверено на",
  first_deposit: "Первый депозит",
  reward: "Награда ",
  inbox: "Входящие",
  manual_bonus: "Ручной бонус ",
  review: "Обзор",
  reviews: "Отзывы",
  review_list: "список отзывов",
  review_detail: "Подробная информация по отзывам",
  reply_review: "Ответить на отзыв",
  comment: "Комментарий",
  reply: "Ответ",
  recipient_no: "Номер получателя",
  question : "Вопрос",
  rating: "Рейтинг",
  content: "Контент",
  image: "Содержание",
  monthly_rating: "Ежемесячный рейтинг",
  affiliate : "Агент",
  affiliate_list: "Список агентов",
  affiliate_code: "Код агента",
  approved_by: "Одобрено",
  approved_date: "Дата одобрения",
  bank_affiliate : "Банк агента",
  bank_id: "ID банка",
  ticket_detail_affiliate : "Подробная информация по тикету агента",
  pending_application: "Заявка на рассмотрении",
  pending_review_withdrawal: "Выводы на рассмотрении ",
  unblock_affiliate : "Разблокировать агента",
  wallet_adjust: "Корректировать кошелек",
  comm_package: "Пакет связи",
  affiliate_id: "ID агента ",
  sub_account_detail: "Подробная информация суб-аккаунта",
  daily_winlose_affiliate : "Ежедневный выигрыш/проигрыш (агент)",
  daily_deposit_affiliate : "Ежедневный депозит (агент)",
  export_excel: "Экспорт Excel ",
  get_tac: "Запросить одноразовый пароль",
  tac_code: "Одноразовый пароль",
  expiry_date: "Дата окончания",
  inactive: "Неактивный",
  last_deposit_date: "Дата последнего депозита",
  coupon: "Купон",
  allocated: "Назначено",
  claimed: "Заявлено",
  approved: "Одобрено",
  coupon_code: "Код купона",
  coupon_quota: "Квота купона",
  current_allocated: "Текущий назначенный",
  new_allocated: "Новый назначенный",
  update : "Обновить",
  copy: "Копировать",
  bonus_rate_percent : "Процент бонусной ставки",
  coupon_desc: "Описание купона",
  both: "Оба",
  issue_free_spin: "Выдать фри спин",
  game: "Игра",
  max_win_amount: "Максимальная сумма выигрыша",
  utm_list: "Список UTM",
  search_by_member: "Поиск по участникам",
  campaign: "Кампания",
  deposited: "Внесенная сумма",
  search_by_id: "Поиск по ID",
  get_bank_tac: "Запросить одноразовый пароль банка",
  bank_statement_daily: "Банковская выписка (ежедневная)",
  transfer_type: "тид перевода",
  audit_freebies_list: "Список бесплатных аудитов",
  acknowledge: "Подтвердить",
  submit_acknowledgement: "Подать подтверждение",
  is_ack: "Подтверждено",
  yes: "Да ",
  no: "Нет ",
  audit_rescue_fund_list: "Провести аудит списка фонда спасения",
  global_setting: "Глобальные настройки",
  signup_ip: "IP регистрации",
  last_login_ip: "IP последнего входа",
  last_login_time: "Время последнего входа",
  link: "Ссылка",
  is_default: "По умолчанию",
  is_public: "Общедоступный",
  bank_group: "Группа банков",
  set_default: "Установить по умолчанию",
  group_id: "ID группы",
  group_name: "Название группы ",
  provider_maintenance: "Техническое обслуживание",
  provider_code: "Код провайдера",
  provider_name: "Название провайдера ",
  withdrawal_limit: "Лимит вывода ",
  limit_id: "ID лимита",
  limit_name: "Название лимита",
  daily_amount: "Ежедневная сумма",
  daily_frequency: "Ежедневная частота",
  promotion_id: "ID  промоакции",
  promotion_name: "Название промоакции",
  withhold_bonus: "Удержать бонус",
  withhold_amount: "Удержать сумму",
  withhold_amt: "Удержать сумму",
  max_withdraw_amt: "Максимальная сумма вывода",
  max_withdraw_amount: "Максимальная сумма вывода",
  monday: "Понедельник",
  tuesday: "Вторник",
  wednesday: "Среда",
  thursday: "Четверг",
  friday: "Пятница",
  saturday: "Суббота",
  sunday: "Воскресенье",
  start_time: "Время начала",
  end_time: "Время окончания",
  day: "День / дни",
  coupon_status: "Статус купона",
  campaign_id: "ID кампании",
  campaign_name: "Название кампании",
  promotion_group: "Группа промоакций",
  referee_list: "Список рефералов",
  account_verified: "Аккаунт верифицирован",
  verified_date: "Данные верифицированы",
  ticket_list: "Список тикетов",
  vip_id: "Vip ID",
  vip_name: "Название Vip ",
  self_rebate_rate: "Процент самовозврата (%)",
  downline_rebate_rate: "процент скидки нижестоящей линии (%)",
  provider: "Провайдер ",
  match_id: "ID матча",
  home_team: "Домашняя команда ",
  away_team: "Команда-гость",
  home_team_new: "Новая домашняя команда",
  away_team_new: "Новая команда-гость",
  updated_by: "Обновлено",
  updated_on: "Обновлено",
  home_score: "Домашний счет",
  away_score: "Гостевой счет",
  home_score_new: "Новый домашний счет",
  away_score_new: "Новый гостевой счет",
  team: "Команда",
  match_time: "Время матча",
  match_round: "Раунд матча",
  home_group: "Домашняя группа",
  away_group: "Гостевая группа",
  match: "Матч",
  match_status: "Статус матча",
  insert: "Вставлять",
  pin: "Закрепить",
  bet_list: "Список Ставок",
  result_list: "Список Результатов",
  bet_id: "ID ставки",
  bet_home: "Ставка домашний",
  bet_away: "Ставка гостевая ",
  bet_on: "Поставить на",
  min_deposit: "Мин депозит",
  min_withdrawal: "Мин вывод",
  raise_deposit_ticket: "Поднять Тикет Депозита",
  method: "Способ",
  one_time_depositor: "Игрок с одним депозитом",
  current_month_non_depositor: "В текущем месяце нет депозитов",
  current_month_no_login: "В текущем месяце нет входов в систему",
  ticket_date: "Дата тикета",
  ftd_amount: "сумма ПД ",
  bonus_issue: "Выпуск бонуса",
  promotion_summary: "Краткий отчет по промоакциям",
  promotion_summary_detail: "Краткий отчет по промоакциям (детальный)",
  claim_frequency: "Запросить частоту",
  provider_list: "Список провайдеров",
  platform_winlose: "Выигрыш/проигрыш платформы",
  adjustment_amount: "Корректировка суммы",
  referee_count: "Количество судей",
  category: "Категория",
  update_vip: "Обновить VIP",
  promotion_signup: "Регистрация промоакции",
  provider_bet_limit: "Лимит ставки провайдера",
  update_member_bet_limit: "Обновить лимит ставки участника",
  bet_limit: "Лимит ставки ",
  sports_game: "Спорт / игра",
  league_name: "Название Лиги",
  home_team_name: "Название домашней команды",
  away_team_name: "название гостевой команды",
  wl_status: "Статус выигрыш/отыгрыш",
  available_bank_account: "Доступный банковский счеи",
  group_bank_account: "Группа банковских счетов",
  edit_bank_group: "Редактировать Группу Банков",
  edit_bank_account_group: "Редактировать группу банковских счетов",
  redeposit: "Повторный депозит",
  upline: "Вышестоящий ",
  downline: "Нижестоящий ",
  available_promotion: "Доступные промоакции",
  group_promotion: "Группа промоакций",
  edit_promotion_group: "Редактировать группу промоакций",
  edit_promotion_group_norm: "Управлять промоакциями в группе",
  balance_before: "Баланс до ",
  balance_after: "Баланс после",
  signup_count: "Количество регистраций",
  verified_count: "Количество верифицированных",
  active_member: "Активный участник ",
  ftd_count: "Кол-во ПД ",
  daily_summary_company: "Ежедневный краткий отчет (компания)",
  daily_summary_operator: "Ежедневный краткий отчет (оператор)",
  daily_summary_member: "Ежедневный краткий отчет (участник)",
  daily_ledger_operator: "Ежедневный реестр (оператор)",
  bonus_list: "Список бонусов",
  ltd_date: "Дата последнего депозита",
  adjustment_log: "Журнал корректировок",
  get_inbox: "Получить входящие",
  is_claimed: "Запрошено",
  mix_parlay: "Микс экспресс",
  event: "Событие",
  result_changes_log: "Журнал изменение результатов",
  view_detail: "Посмотреть подробную информацию",
  total_referee: "Всего рефералов",
  verified_signup: "Верифицированы / зарегистрироваться",
  ftd: "ПД / первый депозит",
  raw_msg: "Сообщение RAW",
  unselect_all: "Отменить выбор всего",
  select_all: "Выбрать все",
  edit_bet_limit: "Редактировать лимит ставок",
  provider_game_off: "Провайдер игры выкл",
  provider_hot_game: "Провайдер горячей игры",
  game_id : "ID игры",
  game_list: "список игр",
  off_list: "Список выключенных",
  provider_rtp: "Провайдер RTP",
  rtp: "RTP",
  signup_date: "Дата регистрации",
  free_credit: "Бесплатный кредит",
  downline_rebate: "Скидка нижестоящей",
  game_rebate: "Скидка игры",
  rebate: "Скидка",
  ftd_date: "Дата ПД",
  provider_winlose_company: "выигрыш/проигрыш провайдера (компания)",
  provider_winlose_operator: "выигрыш/проигрыш провайдера (оператор)",
  already_hit: "Уже попал",
  ongoing: "Текущий",
  members_export: "Участник (экспортировать)",
  get_recent_deposit: "Получить последний депозит ",
  recent_deposit: "Недавний депозит",
  survey_list: "Список опросов",
  modified_on: "Измененный",
  cms: "CMS",
  announcement_banner: "Баннер с объявлением",
  promotion_banner: "Баннер с промоакцией",
  slide_banner: "Слайд баннер",
  seo_page: "Страница SEO",
  en_title: "Заголовок (EN)",
  cn_title: "Заголовок (CN)",
  local_title: "Заголовок (локальный)",
  en_img: "Изображение (EN)",
  cn_img: "Изображение (CN)",
  local_img: "Изображение (локальный)",
  before_login: "До входа",
  after_login: "После входа",
  en: "EN",
  move_up: "Перемещать вверх",
  move_down: "Перемещать вниз",
  banner_type: "Вид баннера",
  default_order: "Порядок по умолчанию",
  item_order: "Порядок элементов",
  title: "Заголовок ",
  banner_id: "ID баннера",
  order: "Порядок",
  body: "Основной текст",
  en_image: "Изображение (EN)",
  local_image: "Изображение (локальный)",
  move: "Перемещать",
  en_img_desktop: "Изображение десктоп (EN)",
  cn_img_desktop: "Изображение десктоп (CN)",
  local_img_desktop: "Изображение десктоп (локальный)",
  en_img_mobile: "Изображение мобайл (EN)",
  cn_img_mobile: "Изображение мобайл (CN)",
  local_img_mobile: "Изображение мобайл (локальный)",
  login_required: "Требуется логин",
  new_window_tab: "Новое окно / вкладка",
  current_page: "Текущая страница",
  target: "Цель",
  event_filter: "Фильтр событий",
  alt: "Alt",
  href: "Href",
  image_desktop: "Десктопное изображение",
  image_mobile: "Мобильное изображение",
  en_alt: "Alt (EN)",
  local_alt: "Alt (локальный)",
  en_href: "Href (EN)",
  local_href: "Href (локальный)",
  en_image_desktop: "Десктопное изображение (EN)",
  active_period: "Активный период",
  en_item: "Элемент (EN)",
  local_item: "Элемент (локальный) ",
  meta_title: "Мета-заголовок",
  meta_keywords: "Мета ключевые слова ",
  meta_url: "Мета URL",
  meta_canonical: "Мета canonical ",
  meta_author: "Мета author",
  meta_publisher: "Мета Publisher",
  meta_lang: "Мета язык",
  meta_desc: "Мета описание",
  meta_image: "Мета изображение",
  page: "Страница",
  item: "Элемент",
  remove_desktop_image: "Убрать десктопное изображение",
  remove_mobile_image: "Убрать мобильное изображение",
  page_name: "Название страницы",
  login_date: "Дата входа",
  ftd_amount_min: "Мин сумма ПД",
  ftd_amount_max: "Макс сумма ПД",
  fl_provider_code: "Первый запуск провайдера",
  fl_game_id: "Первый запуск ID Игры",
  fl_game_name: "первый запуск название игры",
  top_deposit: "Топ депозит",
  top_withdrawal: "Топ вывод",
  top_promotion: "Топ промоакция",
  outstanding_balance: "Непогашенный баланс ",
  last_update_time: "Время последнего обновления",
  trace: "Отслеживать",
  trace_outstanding: "Отслеживать задолжность",
  outstanding: "Непогашенный ",
  clear_outstanding: "Очистить непогашенные",
  meta_image_url: "Мета изображение URL ",
  member_bonus: "Бонус участника",
  crm_list: "Список CRM",
  advance_search: "Расширенный поиск",
  deposit_count_from: "Количество депозитов от ",
  deposit_count_to: "Киличество депозитов до",
  deposit_amount_from: "Сумма депозитов от",
  deposit_amount_to: "Сумма депозитов до",
  min_day_no_login: "Мин дней без входа в систему",
  min_day_no_deposit: "Мин дней без депозита",
  last_login: "Последний вход в систему",
  last_deposit: "последний депозит",
  phone: "Телефон",
  email: "Email",
  ip_whitelist: "Белый список IP",
  ip: "IP",
  payment_option: "Способ оплаты",
  payment_mode: "Режим оплаты",
  payment_desc: "Описание платежа",
  success: "УСПЕШНО",
  failed: "НЕ УДАЛОСЬ",
  bank_member_ewallet: "Банк участника (электронный кошелек)",
  processing: "в обработке ",
  recipient_bank_id: "ID банка получателя",
  recipient_bank_acc_no: "Номер банковского счета получателя",
  ticket_auto_withdrawal_log: "Журнал тикетов (автовывод)",
  resubmit_ticket: "Повторно отправить тикет",
  ticket_export: "Тикет (экспортировать)",
  export_deposit: "Экспортировать (депозит)",
  export_deposit_all: "Экспортировать все (депозит)",
  export_withdrawal: "Экспортировать (вывод)",
  export_withdrawal_all: "Экспортировать все (вывод)",
  export_member_all: "Экспортировать все (участник)",
  processed_rejected: "Обработано (отклонено)",
  channel: "Каннал",
  influencer: "Инфлюенсер",
  ticket_id: "ID тикета",
  recommend: "Рекомендовать",
  sequence: "Последовательность",
  statement_info: "Информация по выписке",
  slots: "Слоты",
  livecasino: "Live казино",
  sportsbook: "Спорт",
  cockfight: "Петушиные бои",
  member_list: "Список участников",
  operator: "Оператор",
  game_balance: "Баланс игры",
  claim_limit: "Запросить лимит ",
  max_withdraw_multiple: "Макс множественный вывод",
  payment_gateway: "Платежный сервис",
  min_limit: "Мин лимит",
  max_limit: "Макс лимит",
  total: "Всего",
  rebate_summary: "Краткий отчет скидка",
  rebate_summary_daily: "ежедневный краткий отчет скидка",
  rebate_member: "Скидка участника",
  self: "Само ",
  system_balance: "Баланс ситемы",
  rejected_onload: "Отклонено (загрузка)",
  no_bonus: "Нет бонусов",
  audit_ticket: "Аудит тикета",
  review_ticket: "Проверить тикет ",
  edit_promotion_group_norm_seq: "Управлять последовательностью промоакций в группе",
  signup_bonus: "Регистрация бонуса",
  settlement_type: "Тип урегулирования",
  carry_over: "Перенести",
  comm_sports: "Комиссия (спорт)",
  comm_slots: "Комиссия (слоты)",
  comm_livecasino: "Комиссия (live казино)",
  comm_cockfight: "Комиссия (петушиные бои)",
  comm_others: "Комиссия (другое)",
  update_comm: "Обновить комиссию ",
  update_carry_over: "Обновить перенос",
  ewallet: "Электронный кошелек",
  withdrawal_list: "Список вывода",
  audit_withdrawal: "Провести аудит вывода",
  daily_withdrawal: "Ежедневный вывод",
  adjustment_log_affiliate : "Журнал корректировок",
  daily_statement_affiliate : "Ежедневная выписка (агент)",
  earning: "Заработок",
  pnl: "Прибыль и убыток",
  review_affiliate_ticket: "Проверить тикет агента",
  audit_affiliate_ticket: "Провести аудит тикета агента",
  turnover_downline: "Отыгрыш (нижестоящий)",
  valid_turnover_downline: "Величина отыгрыш (нижестоящий)",
  winlose_downline: "Выигрыш/проигрыш (нижестоящий)",
  bet_count_downline: "Количество ставок (нижестоящий)",
  turnover_member: "Отыгрыш (участник)",
  valid_turnover_member: "Действительный отыгрыш (участник)",
  winlose_member: "Выигрыш/проигрыш (участник)",
  bet_count_member: "Количество ставок (участник)",
  dashboard_affiliate : "Панель инструментов (агент)",
  total_agent: "Всего агент",
  top_turnover: "Топ отыгрыш ",
  bonus_count: "Количество бонусов",
  deposit_amount_downline: "сумма депозита (нижестоящий)",
  deposit_count_downline: "Количество депозитов (нижестоящий)",
  bonus_amount_downline: "Сумма депозита (нижестоящий)",
  bonus_count_downline: "количество бонусов (нижестоящий)",
  deposit_amount_member: "сумма депозита (участник)",
  deposit_count_member: "Количество депозитов (участник)",
  bonus_amount_member: "Сумма бонусов (участник)",
  bonus_count_member: "Количество бонусов (участник)",
  verified: "Верифицировано",
  round_id: "ID матча",
  unfinish_round: "Незаконченный раунд",
  smartico_bonus_report: "Отчет по бонусам Smartico",
  unclaimed_amount: "Невостребованная сумма",
  claimed_amount: "Востребованная сумма",
  unclaimed_count: "Невостребованное количество",
  claimed_count: "Востребованное количество",
  submit_time: "Созданная дата",
  deposit_time: "Измененная дата",
  funds_list: "Список тикетов",
  daifu_list_auto_withdrawal: "Список тикетов (автовывод)",
  btn_href: "Кнопка Href",
  btn_text: "Кнопка Text",
  recent_inbox_claim: "Недавние входящие заявки ",
  raise_deposit_ticket_gateway: "Поднять Тикет Депозита (платежный сервис)",
  gateway_acc: "Аккаунт платежного сервиса",
  provider_winlose_member: "выигрыш/проигрыш провайдера (участник)",
  review_by: "Проверено",
  daifu_list_auto_withdrawal_export: "Экспорт тикета (автовывод)",
  retention: "Удержание",
  current_month_active_user: "Текущий месяц активные пользователи",
  current_month_active: "Текущий месяц активные",
  first_month: "Первый месяц",
  fmwinlose: "выигрыш/проигрыш ПМ",
  fmdeposit_amount: "Сумма депозитов ПМ",
  cohort: "Когорта",
  promotion_withdrawal_summary: "Краткий отчет вывода по промоакциям",
  promotion_withdrawal_summary_detail: "Краткий отчет вывода по промоакциям (детальный)",
  unique_player: "Уникальный игрок",
  year: "Год / года",
  audit_time_modified: "Измененная дата",
  audit_time_created: "Созданная дата",
  approve_time: "Измененная дата",
  unique_login_count: "Количество уникальных входов в систему",
  unique_deposit_count: "Количество уникальных депозитов",
  unique_withdrawal_count: "Количество уникальных выводов",
  second_deposit_count: "Количество вторых депозитов",
  unique_login: "Уникальный вход",
  unique_withdrawal: "Уникальный вывод",
  second_deposit: "Второй депозит",
  deposit_withdrawal_different: "Разница деп/вывод",
  ngr: "NGR",
  audit_list: "Список аудита",
  rollback_count: "Количество откатов",
  rejected_ticket_id: "ID отклоненного тикета",
  rollback: "Откат",
  recipient_bank_acc_holder: "Владелец банковского счета получателя ",
  reject_date: "Дата отказа",
  processing_date: "Дата обработки ",
  manual_approve: "Одобрить (ручной)",
  pending_review_funds: "Тикет на рассмотрении",
  table_id: "ID стола",
  member_label: "Ярлык участника",
  label_name: "Название ярлыка",
  label: "Ярлык",
  available_label: "Доступный ярлык",
  iframe: "Iframe",
  iframe_url: "Iframe URL",
  exchange_rate: "Курс обмена",
  rate: "Ставка",
  rate_php: "Курс PHP",
  ticket_withdrawal_rollback: "Тикет откат вывода",
  smartico_bonus_report_expired: "Отчет бонусов Smartico (истекший)",
  reward_type: "Тип награды",
  turnover_rebate: "Скидка отыгрыша",
  turnover_rebate_1: "Уровень VIP",
  turnover_rebate_2: "Уровень отыгрыша",
  vip_cycle_day: "VIP Cycle Day",
  is_addon: "Это Addon",
  no_reward: "награды нет",
  cash: "Наличные",
  cs: "Клиентский сервис",
  social_platform: "Социальная платформа",
  edit_vip: "Редактировать VIP ",
  edit_vip_provider: "Редактировать VIP провайдер",
  turnover_tier: "уровень отыгрыша",
  rebate_rate: "Процент скидки",
  edit_turnover_tier: "Редактировать уровень отыгрыша",
  delete_turnover_tier: "Удалить уровень отыгрыша",
  vip_log: "Журнал VIP",
  member_full_record: "Полный отчет участника",
  before: "До ",
  after: "После",
  maintain: "Поддерживать",
  actual_rebate: "Фактическая скидка",
  rounded_rebate: "Округленная скидка",
  rebate_mode: "Режим скидка",
  inbox_id: "ID входящего",
  rebate_type: "Тип скидки",
  promotion_type: "Вод промоакции",
  bonus_rate_1: "Процент 1(%)",
  bonus_rate_2: "Процент 2(%)",
  bonus_rate_3: "Процент 3(%)",
  bonus_rate_4: "Процент 4(%)",
  bonus_rate_5: "Процент 5(%)",
  bonus_rate_6: "Процент 6(%)",
  bonus_rate_7: "Процент 7(%)",
  bonus_rate_8: "Процент 8(%)",
  bonus_rate_9: "Процент 9(%)",
  bonus_rate_10: "Процент 10(%)",
  delete_all: "Удалить все",
  rescue_fund: "Фонд спасения",
  up: "Вверх",
  down: "Вниз",
  rate_percent: "Процент (%)",
  cycle: "Цикл",
  actual_amount: "Фактическая сумма",
  rounded_amount: "Округленная самма",
  rescue_id: "ID спасения",
  rescue_name: "Название спасения",
  min_lose: "Мин проигрыш",
  max_payout: "Макс выплата",
  payout_method: "способ выплаты",
  target_group: "Целевая группа",
  member_vip_id: "ID участника VIP",
  daily: "Ежедневный",
  weekly: "Еженедельный",
  monthly: "Ежемесячный",
  edit_batch: "редактировать Batch",
  current_level: "текущий уровень",
  next_level: "Следующий уровень",
  bet_value: "Стоимость ставки",
  line_bet: "Ставка на линию",
  total_round: "Всего раундов",
  audit_by: "Аудит проведен",
  possible_next_level: "вероятный следующий уровень",
  maintain_deposit: "Поддержать депозит",
  maintain_turnover: "Поддержать отыгрыш",
  starting_deposit: "Стартовый депозит",
  starting_turnover: "Стартовый отыгрыш",
  cycle_deposit: "Цикличный депозит",
  cycle_turnover: "Цикличный отыгрыш",
  vip_list: "Список VIP",
  up_maintain: "Поддерживать вверх",
  down_lowest: "Самый низкий вниз",
  manual: "Ручной",
  daily_winlose_game: "Ежедневный выигрыш/проигрыш (Игра)",
  actionaff: "Действие (Агент)",
  onload: "Загрузка",
  update_status: "Обновить статус",
  role_settings: "Настройки роли",
  customer_services: "Служба поддержки клиентов",
  marketing: "Маркетинг",
  finance: "финансы",
  payment: "Платеж ",
  risk_management: "Риск менеджмент",
  pt: "РТ",
  wallet_history: "История кошелька",
  ticket_amount: "Сумма тикета",
  ignore_risk: "Игнорировать риск",
  permitted_amount: "Разрешенная сумма",
  all_pending_ticket: "Все тикеты на рассмотрении",
  rescue_fund_summary: "Краткий отчет фонд спасения",
  rescue_fund_summary_daily: "Ежедневный отчет фонд спасения",
  rescue_fund_member: "Фонд спасения участника",
  master: "Мастер",
  account_type: "Тип аккаунта",
  freeze: "Заморозить",
  domain_member_setup: "Настройка домена сайта участника",
  domain: "Домен",
  domain_list: "Список доменов",
  domain_application: "Приложение домены",
  domain_status: "Статус домена",
  domain_group: "Группа доменов",
  operator_id: "ID оператора",
  domain_type: "Тип домена",
  module: "Модуль",
  template: "Шаблоны",
  custom: "Покупатель",
  default: "По умолчанию",
  payment_provider: "Платежный провайдер",
  payment: "Платеж ",
  deactivate: "Неактивный",
  name_server: "Название сервера",
  server_account: "Счет сервера",
  service_provider: "Провайдер сервера",
  process: "Процесс",
  provider_operator: "Оператор провайдера",
  bet_limit_member: "@:ui.bet_limit (@:ui.member)",
  global: "Расширенные настройки",
  second_id: "Второй ID",
  unverified: "Неверифицированный",
  pt_affiliate : "сборы за платформу агента (%) ",
  recipient_bank: "Банк получателя",
  deposit_type: "Тип депозита",
  security_fund: "Страховой фонд",
  adjust_balance_op: "Корректировать кошелек оператора",
  adjust_security_deposit_op: "Корректировать страховой фонд оператора",
  marquee: "Бегущая строка",
  marquee_content: "Содержание бегущей строки",
  edit_marquee: "редактировать бегущую строку",
  domain_available: "Доступный домен",
  daily_withdrawal_frequency: "Частота ежедневного вывода",
  maintenance: "Техническое обслуживание",
  max_withdrawal: "Макс вывод",
  min_balance: "Минимальный баланс",
  affiliate_report: "Отчеты агента",
  cash_balance: "Баланс наличных",
  copy_success: "Скопировано успешно!",
  copy_failed: "Не удалось скопировать",
  your_website: "Ваш веб-сайт",
  correction_promo: "Добавить промоакцию",
  others: "другое",
  audit_log: "Аудит журнала",
  view: "просмотр",
  price: "цена",
  package_level: "Уровень пакета",
  bo_right: "Право ВО",
  english: "Английский ",
  simplified_chinese: "Китайский (CN)",
  traditional_chinese: "Китайский (TW)",
  philippine: "филипинский",
  thai: "тайский",
  vietnamese: "вьетнамский",
  indonesian: "индонезийский",
  myanmar: "Бирманский",
  japanese: "Японский",
  korean: "Корейский",
  package_type: "Тип пакета",
  full_back_office_access_right: "Права на полный доступ к бек-офису",
  read_only_back_office: "Бек-офис только чтение",
  language: "язык",
  lang_code: "Код языка",
  description: "Описание",
  provider_type: "Тип провайдера",
  logo: "Лого",
  theme_provider: "Тема провайдера",
  theme_content: "Контент провайдера",
  content_id: "Контент ID",
  content_desc: "Описание контента",
  theme_content_position: "Позиция тема контент",
  theme: "Тема",
  theme_code: "Код темы",
  theme_name: "Название темы",
  color: "Цвет",
  position: "Позиций",
  site_name: "Название сайта",
  theme_color: "Цвет темы",
  theme_purchased: "Тема куплено",
  total_purchased: "Всего куплено",
  purchased_date: "Дата покупки",
  purchase: "Покупка",
  total_site: "Всего сайтов",
  content_setup: "Настройки контента",
  site_list: "Список сайтов",
  site_id: "ID сайта",
  draft_version: "Черновая версия",
  prod_version: "Рабочая версия",
  production_version: "Рабочая версия",
  info: "Инфо",
  setting: "Настройки",
  site_info: "Инфо по сайту",
  menu: "Меню",
  game_menu: "Меню игры",
  special_menu: "Специальное меню",
  setting_menu: "Настройки меню",
  error: "Ошибка",
  sync_all: "Синхронизировать все",
  theme_content_group: "группа тема контент",
  content_group: "Группа контент",
  content_group_desc: "Описание группы контента",
  parent_content_id: "ID родительского контента",
  bo_default_domain: "ВО домен по умолчанию",
  domain_id: "ID домена",
  deactive: "Деактивированный",
  site_sync: "Синх сайт",
  upload: "Загрузить",
  comingSoon: "Скоро",
  profile_setting: "Настройки профиля",
  bank: "Банк",
  company: "Компания",
  own: "Владеть",
  operator_setting: "Настройки оператора",
  external_id: "Внешний ID",
  ticket: "Тикет",
  bank_owner: "Владелец банка",
  exchanged_currency: "Обмениваемая валюта",
  company_bank_owner: "владелец банка компании",
  ticket_list_member: "Список тикетов (участник)",
  game_name_exclude: "Исключить название игры",
  tab: "Вкладка",
  about_us: "о нас",
  privacy_policy: "Политика конфиденциальности",
  responsible_gaming: "Отвественная игра",
  banking: "Банковские операции",
  faqs: "Часто задаваемые вопросы",
  advertisement: "Реклама",
  px_pixel_id: "PX Pixel ID",
  px_token: "PX Token",
  af_dev_key: "Af Dev Key",
  af_apps_id: "Af Apps ID",
  pp_tid: "PP TID",
  pp_pid: "PP PID",
  pp_aid: "PP AID",
  gtm_id: "GTM ID",
  service_provider_url: "URL провайдера услуг",
  script_inject: "Вставить скрипт",
  head_script: "Head Script",
  body_script: "Body Script",
  ads_id: "ID объявления",
  member_detail: "Подробная информация по участнику",
  memberreport: "Отчет по участнику",
  member_log: "Журнал участника",
  general: "Общее",
  top_theme: "Главная тема",
  hot_game: "Горячие игры",
  hot_list: "Список Горячие",
  new_game: "Новая игра",
  popular_game: "Популярная игра",
  featured_game: "Рекомендованная игра",
  new_list: "Список Новые",
  popular_list: "Список Популярные",
  featured_list: "Список Рекомендованный",
  provider_new_game: "Провайдер Новые Игры",
  provider_popular_game: "Провайдер Популярные Игры",
  provider_featured_game: "Провайдер Рекомендованные Игры",
  website: "Веб-сайт",
  site_customization: "Настройки сайта",
  export_all: "Экспортировать все",
  export_one: "Экспортировать (текущая страница)",
  daily_ledger: "Ежедневный реестр ",
  daily_ledger_member: "Ежедневный реестр (участник)",
  promotion_signup_unused: "Неиспользованный промо за регистрацию",
  promotion_signup_ongoing: "Текущая промоакция за регистрацию",
  promotion_signup_winlose: "выигрыш/проигрыш промоакция за регистрацию ",
  promotion_signup_winlose_operator: "выигрыш/проигрыш промоакция за регистрацию (оператор)",
  promotion_signup_winlose_member: "выигрыш/проигрыш промоакция за регистрацию (участник)",
  total_player_balance: "Всего баланс игроков",
  search_all: "Искать все",
  mbsetting: "Настройки",
  todays_highlights: "Главные события дня",
  deposit_player: "Депозит игрока",
  withdrawal_player: "Вывод игрока",
  kill_rate: "Вероятность поражения",
  login_player: "Логин игрока",
  operation_management: "Операционный",
  game_management: "Игра",
  member_management: "Участник",
  affiliate_management: "Агент",
  promotion_management: "Промоакция",
  mbcampaign: "Кампания",
  promo_allday: "Все дни",
  promo_daily: "Ежедневный",
  promo_daily_first_deposit: "Ежедневный первый депозит",
  promo_deposit_monthly: "Ежемесячное количество депозитов",
  promo_deposit_signup: "Количество депозитов по регистрациям",
  promo_deposit_weekly: "Еженедельное количество депозитов",
  promo_newbie: "Новичок",
  promo_once: "Однажды",
  dd_review: "Пересмотреть",
  game_provider_management: "Провайдер",
  exchanged_amount: "Сумма обмена",
  operator_summary: "Краткий отчет по оператору",
  business_id: "Бизнес ID",
  game_name_exclude_log: "Журнал исключения названия игры",
  cn: "CN",
  local: "Локальный",
  taken: "Приняты",
  receiver_bank: "Банк получателя",
  receiver_bank_acc_no: "Номер банковского счета получателя",
  receiver_bank_acc_holder: "Владелец банковского счета получателя ",
  add_balance: "Добавить баланс",
  deduct_balance: "Вычесть баланс",
  sync_site_content: "Синхронизировать контент сайта",
  payment_setting: "Настройки платежек",
  payment_own: "Собственная",
  payment_global: "Глобальная",
  livechat: "LiveChat",
  chat_id: "Лицензионный ключ LiveChat",
  chat_provider: "Провайдер LiveChat",
  auto_cycle: "Цикл",
  auto_all: "Все",
  completed_amount: "Завершенная сумма",
  website_launched: "Сайт запущен",
  total_operators: "Всего операторы",
  today_active: "Сегодня активен",
  new_player_verified_signup: "Новый игрок верифицирован / зарегистрирован",
  total_players: "Всего игроки",
  depo_withdrawal_diff: "ДЕП-ВЫВОД разница",
  claim_count: "Количество заявок",
  ggr: "GGR",
  member_balance: "Баланс участника",
  players: "Игроки",
  provider_pt: "РТ провайдера",
  base: "База",
  topup_id: "ID пополнения ",
  credential: "Учетные данные",
  credential_1: "Учетные данные 1",
  credential_2: "Учетные данные 2",
  credential_3: "Учетные данные 3",
  credential_4: "Учетные данные 4",
  credential_5: "Учетные данные 5",
  credential_6: "Учетные данные 6",
  credential_7: "Учетные данные 7",
  credential_8: "Учетные данные 8",
  credential_9: "Учетные данные 9",
  credential_10: "Учетные данные 10",
  limit: "Лимит ",
  create: "Создать",
  hint: "Подсказка",
  quickSetup: "Быстрые настройки",
  next: "Следующий",
  setUpTheme: "Настройка темы",
  checkOut: "Проверять",
  standardPackage: "Стандартный пакет",
  siteName: "Название сайта",
  information: "Информация",
  useThisTemplate: "Использовать этот шаблон",
  summary: "Краткий отчет",
  createOperatorAccount: "Создать аккаунт оператора",
  operatorId: "ID оператора",
  operatorPwd: "Пароль оператора",
  new_website: "Новый вебсайт",
  operator_information: "Информация оператора",
  bo_link: "Ссылка ВО",
  daily_summary_sms: "Ежедневный краткий отчет SMS",
  daily_summary_sms_operator: "Ежедневный краткий отчет SMS оператор",
  daily_summary_sms_operator_detail: "Ежедневный краткий отчет SMS оператора подробно",
  sms_count: "Количество SMS",
  provider_winlose_operator_pt: "Выигрыш-проигрыш провайдера (РТ оператора)",
  pt_on: "РТ включен",
  share_operator: "Поделиться с оператором",
  share_company: "Поделиться с компанией",
  token_log: "Журнал токена",
  template_code: "Код шаблона",
  template_name: "Название шаблона",
  mini_game: "Мини игра",
  max_game_reward: "Макс награда за игру",
  max_chance_per_day: "Макс шанс в день",
  is_recurring_chance: "Повторяющийся",
  token_request: "Токен",
  enabled: "Включен",
  disabled: "Выключен",
  unlimited: "Безлимитный",
  max_chance_unlimited: "Макс шанс в день",
  mini_game_template: "Шаблон мини игры",
  reward_code: "Код награды",
  reward_name: "Название награды",
  reward_description: "Описание награды",
  reward_probability: "Вероятность награды",
  total_game: "Всего игры",
  total_played_mini_game: "Всего сыграно мини игр",
  total_played_mini_game_detail: "Всего сыграно мини игр подробно",
  total_played_mini_game_detail_operator: "Всего сыграно мини игр подробно (оператор)",
  daily_pnl_operator: "Ежедневная прибыль и убыток (оператор)",
  token: "Токен",
  token_1: "Токен 1",
  token_2: "Токен 2",
  token_3: "Токен 3",
  token_4: "Токен 4",
  token_5: "Токен 5",
  token_6: "Токен 6",
  token_7: "Токен 7",
  cash_1: "Наличные 1",
  cash_2: "Наличные 2",
  cash_3: "Наличные 3",
  cash_4: "Наличные 4",
  cash_5: "Наличные 5",
  cash_6: "Наличные 6",
  cash_7: "наличные 7",
  daily_login: "Ежедневная регистрация (ежедневный вход)",
  daily_login_update: "Ежедневная регистрация (ежедневный вход) обновить",
  game_result_reward: "Результат игры (награды)",
  current_streak: "Текущий стрик",
  login_streak: "Логин-стрик",
  total_token: "Всего токены",
  total_mini_game_token_used: "Всего использовано токены мини игры",
  total_mini_game_token_used_detail: "Всего использовано токены мини игры подробно",
  total_mini_game_token_used_detail_operator: "Всего использовано токены мини игры подробно (оператор)",
  total_reward: "Всего награды",
  total_mini_game_reward: "Всего награды мини игры",
  total_mini_game_reward_detail: "Всего награды мини игры подробно",
  total_mini_game_reward_detail_operator: "Всего награды мини игры подробно (оператор)",
  token_balance: "Всего баланс",
  free_game_token: "Токен бесплатной игры",
  bo_url: "URL бек-офиса",
  copied: "Скопировано",
  callback: "Коллбек",
  api: "API",
  prefix: "Префикс",
  delimiter: "Разделитель",
  url_callback_deposit: "Callback URL депозита",
  url_callback_withdrawal: "Callback URL вывода",
  url_callback_affiliate : "Callback URL агента",
  url_api_deposit: " Callback URL депозита (API)",
  url_api_withdrawal: " Callback URL вывода (API)",
  url_api_balance: " Callback URL баланса (API)",
  prefix_deposit: "Префикс депозита",
  prefix_withdrawal: "Префикс вывода",
  prefix_affiliate : "Префикс агента",
  prefix_delimiter: "Разделитель агента",
  merchant: "Мерчант",
  app_id: "App ID",
  secret_key: "Секретный ключ",
  deposit_secret_key: "Секретный ключ депозита",
  withdrawal_secret_key: "Секретный ключ вывода",
  partners: "Партнеры",
  partner_name: "название партнера",
  win: "Выиграть",
  manifest: "Манифест",
  crop: "Обрезать",
  cropImage: "Обрезать изображение",
  api_url: "API URL",
  start_date_time: "Дата и время начала",
  end_date_time: "Дата и время окончания",
  authentication_key: "Ключ аутентификации",
  one_week: "1 неделя ",
  two_week: "2 неделя",
  one_month: "1 месяц",
  two_month: "2 месяца",
  six_month: "6 месяцев",
  edit_promotion_end_date: "Редактировать дату окончания промоакции",
  android_app_link: "Ссылка на приложение для Android",
  add_android_app_link: "Добавить ссылку на приложение для Android",
  operator_details: "Подробная информация оператора",
  bsb: "BSB",
  payid: "ID платежа",
  cuit: "CUIT",
  merchant_key: "Ключ мерчанта",
  aes_key: "AES",
  paycode: "Код платежа",
  api_key: "API",
  referral: "Вознаграждение за реферала",
  minimum_deposit: "Минимальный депозит",
  minimum_withdrawal: "Минимальный вывод",
  maximum_withdrawal: "Максимальный вывод",
  cpi: "CPI",
  cpi_enrol: "Регистрация CPI",
  interested: "Заинтересован",
  non_pickup: "Не забрано",
  invalid: "Недействительно",
  cpi_member_list: "Список участников CPI",
  leaderboard: "Таблица лидеров",
  capacity: "Вместимость",
  reward_count: "Количество наград",
  is_settled: "Улажено",
  settlement_date: "Дата расчета",
  prize: "Приз",
  count: "Количество",
  multiplier: "Множитель",
  ranking: "Рейтинг",
  leaderboard_ranking: "Рейтинг лидеров",
  joined_date: "Дата присоединения",
  ready: "Готов",
  busy: "Занят",
  phone_list: "Список телефонов",
  single: "Одиночный",
  batch: "Пакетный",
  cpi_operator_phone_list: "Список телефонов оператора CPI",
  selected: "Выбрано",
  call: "Позвонить",
  private_key: "Закрытый ключ",
  public_key: "Открытый ключ",
  multi_call: "Множественные звонки",
  add_custom: "Добавить пользовательский",
  custom_list: "Пользовательский список",
  assignee: "Назначенный",
  urgency: "Срочность",
  urgency_1: "Низкая",
  urgency_2: "Средняя",
  urgency_3: "Высокая",
  edit_custom: "Редактировать пользовательский",
  cpi_custom_list: "Пользовательский список CPI",
  free_coin_signup: "Бесплатные поинты (Регистрация)",
  free_coin_daily: "Бесплатные поинты (Ежедневно)",
  free_coin_min_withdrawal: "Минимальный вывод (Бесплатные поинты)",
  free_coin_per_unit: "Курс обмена бесплатных поинтов (Поинт = {currency} 1)",
  adjust_free_balance: "Корректировка свободного баланса",
  adjust_free_balance_log: "Журнал свободного баланса",
  signup: "Регистрация",
  adjust: "Корректировать",
  ai_assistant: "ИИ Ассистент",
  en_name: "Имя (EN)",
  cn_name: "Имя (CN)",
  local_name: "Имя (ЛОКАЛЬНОЕ)",
  img_small: "Изображение (Малое)",
  img_large: "Изображение (Большое)",
  small_image: "Малое изображение",
  large_image: "Большое изображение",
  forgot_password: "Забыли пароль",
  update_password: "Обновить пароль",
  contact: "Контакт",
  keyss: "Ключ",
  iv: "IV",
  callback_public_key: "Открытый ключ обратного вызова",
  free_game: "Бесплатная игра",
  version_no: "Номер версии",
  client_id: "ID клиента",
  symmetric_key: "Симметричный ключ",
  deposit_token: "Токен депозита",
  withdrawal_token: "Токен вывода",
  tac_bank: "OTP (Банк)",
  tac_login: "OTP (Вход)",
  tac_signup: "OTP (Регистрация)",
  tac_signup_aff: "OTP (Регистрация партнёра)",
  merchant_name: "Имя торговца",
  tele_status: "Телестатус",
  follow_up: "Последующее действие",
  call_type: "Тип звонка",
  on_call_list: "В списке звонков",
  inbox_valid_day: "Действительный день входящих",
  manual_deposit: "Ручной депозит",
  withdrawal_result: "Результат вывода средств",
  widget_id: "ID виджета",
  property_id: "ID свойства",
  referee: "Вознаграждение рефералу",
  game_result_free_slots: "Результат Игры (Бесплатные Слоты)",
  crypto_address: "Крипто-адрес",
  crypto_network: "Крипто-сеть",
  crypto: "КРИПТО",
  exchange_currency: "Валюта Обмена",
  base_rate: "Базовая Ставка",
  white_label: "White Label",
  aggregator: "Агрегатор",
  deposit_rate: "Ставка депозита",
  withdrawal_rate: "Ставка вывода",
  pending_bet_list_wbet: "Список ожидающих ставок (WBET)",
  bet_amount: "Сумма ставки",
  actual_bet_amount: "Фактическая сумма ставки",
  pending_bet_list_others: "Список ожидающих ставок (Другие Спортсбук)",
  dob: "Дата рождения",
  mail_address: "Почтовый адрес",
  crypto_withdrawal: "Вывод криптовалюты",
  institute_bank_code: "Банковский код учреждения",
  pending_bet_list_9w: "Список ожидающих ставок (9W)",
  linkage: "Связь",
  linkage_op: "Оператор связи",
  member_linkage: "Связь участника",
  risk_weight: "Вес риска",
  full_linkage: "Полная связь",
  total_risk_score: "Общий риск-скор",
  linkage_value: "Значение связи",
  source_occurrence_count: "Количество появлений источника",
  source_last_seen_at: "Последнее обнаружение (источник)",
  target_occurrence_count: "Количество появлений цели",
  target_last_seen_at: "Последнее обнаружение (цель)",
  member_linkage_detail: "Детали связи участника",
  merchant_uid: "Идентификатор продавца",
  merchant_no: "Номер продавца",
  slot_view: "Просмотр слотов",
  settlement_list_affiliate: "Список расчётов (Партнёр)",
  source: "Источник",
  earning_breakdown: "Разбивка дохода",
  deposit_bonus: "Бонус за депозит",
  winlose_turnover: "Выигрыш/Проигрыш/Оборот",
  cost: "Затраты",
  promotion_voucher: "Промо-ваучер",
  voucher_id: "ID Voucher",
  voucher_cash: "Kas Voucher",
  ticketvoucher: "Ваучер тикета",
  ticket_voucher_list_member: "Список ваучеров тикета (участник)",
  ticket_voucher_list: "Список ваучеров тикета",
  pending_review_funds_voucher: "Ожидающие и на проверке ваучеры тикета",
  all_pending_ticket_voucher: "Все ожидающие ваучеры тикета",
  ticket_voucher_detail: "Детали ваучера тикета",
  raise_deposit_ticket_voucher: "Создать ваучер тикета на депозит",
  raise_deposit_ticket_voucher_gateway: "Создать ваучер тикета на депозит (шлюз)",
  sos: "SOS пополнение",
  sos_accumulate_deposit: "SOS пополнение (накопительный депозит)",
  greeting: "Приветствие",
  message: "Сообщение",
  get_voucher: "Получить ваучер",
  get_message: "Получить сообщение",
  voucher: "Ваучер",
  code: "Код",
  redeemed_by: "Использовано",
  redeemed_by_operator: "Использовано (Оператор)",
  redeemed_at: "Использовано в",
  created_at: "Создано в",
  redeemed: "Использовано",
  member_sos_click_log: "Журнал кликов SOS участника",
  member_wallet_voucher_log: "Журнал ваучеров кошелька участника",
  member_voucher_redeemed_log: "Журнал погашения ваучеров участника",
  action_by_operator: "Действие (Оператор)",
  redeem_cash: "Обналичить",
  generate_voucher: "Создать ваучер",
  url_api_freecredit: "URL обратного вызова бесплатного кредита",
  prefix_freecredit: "Префикс бесплатного кредита",
  free_credit_member: "Участник бесплатного кредита",
  free_credit_provider: "Провайдер бесплатного кредита",
  ticket_detail_fcp: "Детали тикета провайдера бесплатного кредита",
  ticket_list_processed: "Список тикетов (Обработанные)",
  mission: "Миссия",
  non_slot_view: "Просмотр без слотов",
  banner: "Баннер",
  trigger: "Триггер",
  event_type: "Тип события",
  action_type: "Тип действия",
  msg_greeting: "Приветствие (Сообщение)",
  msg_title: "Заголовок (Сообщение)",
  msg_body: "Текст (Сообщение)",
  send_message: "Отправить сообщение",
  promo_type: "Тип промо",
  repeatable: "Повторяющийся",
  rules: "Правила",
  clear_outstanding_log: "Очистить журнал задолженности",
  free_credit_withdrawal_amount: "Сумма вывода бесплатного кредита",
  fc_withdrawal_amount: "Сумма вывода FC",
  frozen: "Заморожено",
  transferred: "Переведено",
  voucher_balance: "Баланс ваучера",
  adjust_voucher_balance: "Изменить баланс ваучера",
  free_game_provider: "Провайдер бесплатных игр",
  check_free_spin: "Проверить Free Spin",
  freespin_log: "Журнал Free Spin",
  current_round: "Текущий раунд",
  lines: "Линии",
  expiry_interval_days: "Интервал истечения срока (дни)",
  assign: "Назначить",
  game_code: "Код игры",
  clear_free_credit: "Очистить бесплатный кредит",
  deposit_tier: "Уровень депозита",
  point: "Балл",
  top: "Верх",
  bottom: "Низ",
  leaderboard_banner: "Баннер таблицы лидеров",
  referral_banner: "Реферальный баннер",
  tp_site: "URL Traffic Pool",
  current_icon: "Текущая иконка",
  new_icon: "Новая иконка",
  voucher_redeemed: "Ваучер погашен",
  on_site: "На сайте",
  exclude_own: "Исключить свои",
  voucher_redeemed_detail: "Детали погашенного ваучера",
  gamification: "Геймификация",
  reward_rain: "Reward Rain",
  total_claimed_amount: "Общая полученная сумма",
  min_amount: "Минимальная сумма",
  max_amount: "Максимальная сумма",
  reward_rain_session: "Сессия Reward Rain",
  reward_rain_session_claim: "Получение награды Reward Rain",
  reward_amount: "Сумма награды",
  cta: "CTA",
  api_email: "Электронная почта API",
  api_password: "Пароль API",
  url_callback_voucher: "URL обратного вызова ваучера",
  prefix_voucher: "Префикс ваучера",
  slide_show: "Слайд-шоу",
  ewallet_withdrawal: "Вывод средств с электронного кошелька",
  news: "Новости",
  slug: "Слаг",
  preview_body: "Предпросмотр содержимого",
  full_body: "Полное содержимое",
  normal: "Обычный",
  free_balance: "Бесплатный баланс",
  schema: "Схема",

  tt_pixel_id: "Идентификатор пикселя TT",
  tt_token: "Токен TT",

  free_spin_bulk_issue : "Бесплатные вращения (Массовая выдача)",
}